export const sliderItems = [ 
    {
        id: 1,
        // img: "images/woman-with-pruchase-bag-her-shouelder.png",
        title: "END OF SEASON SALE",
        desc: "ENJOY A FLAT 20% OFF ON OUR END OF SEASON SALE! GRAB YOURS NOW!",
        bg: "fdf3fb",
        bgImg: "https://img.freepik.com/free-photo/close-up-cute-glamour-girl-eavesdropping-clean-closer-with-hand-near-ear-smiling-overhear-con_1258-124543.jpg?t=st=1717345146~exp=1717348746~hmac=03a6ab2678685baaed86c173205e4dd96cdfa23332da20d3c2ef3331e995a782&w=1800"
    },
    {
        id: 2,
        //img: "images/img2.png",
        title: "DISCOVER MORE",
        desc: "EXPLORE AN EXTENSIVE COLLECTION OF HIGH-QUALITY PRODUCTS FOR ALL YOUR NEEDS",
        bg: "fcf1ed",
        bgImg: "https://img.freepik.com/free-photo/sympathetic-girl-with-many-shopping-nets_23-2148316353.jpg?t=st=1717340580~exp=1717344180~hmac=d73e57a3f33e67f945cb55d7f083af0c059685dace01fa733d1664d4fec96dec&w=2000"
    },
    {
        id: 3,
        //img: "images/img1.png",
        title: "SALON SERVICES",
        desc: "INDULGE IN LUXURY AND RELAXATION AT OUR SPA – REJUVENATION AWAITS",
        bg: "fbf0f4",
        bgImg: "https://img.freepik.com/free-photo/stylish-woman-pink-summer-violet-mini-trendy-dress-posing-with-peony-flowers-bouquet-sitting-floor_285396-563.jpg?t=st=1717340061~exp=1717343661~hmac=2b73bd5f892f18d90350545cf89cd32786d2092b1980f7c2ecc737ac755397c0&w=1800"
    },
];

export const categories = [
    {
        id: 1,
        img: "https://lovetowear.in/wp-content/uploads/2023/12/photo1703057582.jpeg",
        title: "SAREES",
        cat: "women"
    },
    {
        id: 2,
        img: "https://images.unsplash.com/photo-1542295669297-4d352b042bca?q=80&w=3087&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        title: "WESTERN",
        cat: "dress"
    },
    {
        id: 3,
        img: "https://jisora.com/cdn/shop/products/0N8A3541_1800x1800.jpg?v=1702018452",
        title: "CO-ORDS",
        cat: "two-piece"
    }
];

export const popularProducts = [
    {
        id: 1,
        img: "https://img.freepik.com/premium-photo/women-s-kanjivaram-soft-silk-banarasi-saree_953724-899.jpg?size=626&ext=jpg&ga=GA1.2.916897158.1703585522&semt=sph",
    },
    {
        id: 2,
        img:"https://img.freepik.com/free-photo/front-view-elegant-girl-red-dress-leans-chair-looks-camera_8353-11655.jpg?size=626&ext=jpg&ga=GA1.1.916897158.1703585522&semt=sph",
    },
    {
        id: 3,
        img:"https://img.freepik.com/free-photo/beautiful-young-woman-wearing-fashionable-clothes-walking-down-street_839833-3813.jpg?size=626&ext=jpg&ga=GA1.1.916897158.1703585522&semt=sph",
    },
    {
        id: 4,
        img:"https://img.freepik.com/premium-photo/pretty-girl-posing-confidently-wearing-traditional-full-dress-photoshoot-ancient-place_658768-552.jpg?size=626&ext=jpg&ga=GA1.1.916897158.1703585522&semt=sph",
    },
    {
        id: 5,
        img:"https://img.freepik.com/free-photo/portrait-woman-beautiful-grey-dress_1303-13052.jpg?size=626&ext=jpg&ga=GA1.1.916897158.1703585522&semt=sph",
    },
    {
        id: 6,
        img: "https://img.freepik.com/premium-photo/photoshoot-indian-lehenga-choli_1012351-1.jpg?size=626&ext=jpg&ga=GA1.1.916897158.1703585522&semt=sph",
    },
    {
        id: 7,
        img: "https://img.freepik.com/free-photo/woman-wearing-high-heels-stocking_23-2150261096.jpg?size=626&ext=jpg&ga=GA1.1.916897158.1703585522&semt=sph",
    },
    {
        id: 8,
        img: "https://img.freepik.com/premium-photo/photo-smiling-little-girl-child_132310-4006.jpg?size=626&ext=jpg&ga=GA1.1.916897158.1703585522&semt=sph",
    },
];